import React from 'react';

import {
  ConversationAuditLogEntry,
  ReservationReleasedReason,
} from 'apis/auditLogs';
import { durationConverter } from 'utils/duration';

import { getLogEntryUserName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationOfferedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_OFFERED'>;
};

const getReservationReleasedReason = (
  reason?: ReservationReleasedReason,
): JSX.Element | null => {
  switch (reason?.type) {
    case 'offline_timeout_passed':
      return (
        <>
          Reservation for{' '}
          <UserLink userId={reason.reserved_agent.id}>
            {getLogEntryUserName(reason.reserved_agent)}
          </UserLink>{' '}
          timed out (offline for over{' '}
          {durationConverter.toString(reason.timeout_in_seconds)})
        </>
      );
    default:
      return null;
  }
};

export const ConversationOffered = ({
  entry,
}: ConversationOfferedProps): JSX.Element => {
  const text = (
    <>
      Conversation is offered to{' '}
      {entry.agents.map((agent, i) => (
        <React.Fragment key={`conversation-offered-${agent.id}`}>
          <UserLink userId={agent.id}>{getLogEntryUserName(agent)}</UserLink>
          {i !== entry.agents.length - 1 ? ', ' : ''}
        </React.Fragment>
      ))}
      {entry.queue_label ? ` in ${entry.queue_label} queue` : ''}
    </>
  );

  const reservationReleasedReason = getReservationReleasedReason(
    entry.reservation_released_reason,
  );

  return (
    <>
      {reservationReleasedReason && (
        <LogEntry entry={entry} text={reservationReleasedReason} />
      )}
      <LogEntry entry={entry} text={text} />
    </>
  );
};
